import { BlockInstanceProps } from '../Block';
import List3Groups from '../../components/List3Groups';
import {
  ContentTypeEnum,
  List3GroupsTypeEnum,
  List3GroupsHeadersEnum,
  BackgroundColorEnum,
} from '../../constants/cms-constants';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  {
    key: 'type',
    definition: controlOptionDefinitions.list3GroupTypes,
  },
  {
    key: 'header',
    definition: controlOptionDefinitions.list3GroupHeaders,
  },
  { key: 'seoWeight', definition: controlOptionDefinitions.SEOWeightTypes },
])
class List3GroupsBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const type = List3GroupsTypeEnum[controlOptions?.type];
    const header = List3GroupsHeadersEnum[controlOptions?.header];
    const seoWeight = controlOptions?.seoWeight;

    let mediaItems;
    blockContent.doQuery((content) => {
      mediaItems = content.getFixedAmountOfType(ContentTypeEnum.MEDIAITEM, 3);
    });

    return (
      <List3Groups
        headerText={block?.header?.main}
        mediaItems={mediaItems}
        link={block?.link}
        type={type}
        header={header}
        backgroundColor={backgroundColor}
        seoWeight={seoWeight}
      />
    );
  }
}

export default List3GroupsBlock;
